import { render, staticRenderFns } from "./mainParametersTab.vue?vue&type=template&id=7f90ea47&"
import script from "./mainParametersTab.vue?vue&type=script&lang=js&"
export * from "./mainParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports